// extracted by mini-css-extract-plugin
export default {"container":"CalendarPage_container__SJH8Y"};